import { withStyles } from '@material-ui/core/styles'
import React from 'react'

const enhance = withStyles(() => ({
  wrapper: {
    padding: 0,
    '& li': {
      padding: '8px 16px',
      height: 90,
      display: 'block',
      animation: 'flickerAnimation 3s infinite',
    },
  },
  line: {
    marginTop: 8,
    display: 'flex',
    justifyContent: 'space-between',
    '&:first-child div': {
      height: 11,
    },
    '& div': {
      height: 8,
      background: '#ccc',
      marginRight: 8,
      borderRadius: 8,
      width: '100%',
    },
  },
  '@keyframes flickerAnimation': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.5 },
    '100%': { opacity: 1 },
  },
}))

function Item({ classes }) {
  return (
    <li>
      <div className={classes.line} style={{ width: '70%' }}>
        <div />
        <div />
      </div>
      <div className={classes.line} style={{ width: '90%' }}>
        <div />
        <div />
        <div />
      </div>
      <div className={classes.line} style={{ width: '60%' }}>
        <div />
        <div />
      </div>
    </li>
  )
}

function Placeholder({ classes }) {
  return (
    <ul className={classes.wrapper}>
      {[1, 2, 3, 4, 5, 6].map((key) => (
        <Item classes={classes} key={key} />
      ))}
    </ul>
  )
}

export default enhance(Placeholder)
